// libraries
import { useCallback, ReactElement, useEffect } from 'react'

// constants
import { HOME_PAGE_URL } from 'constants/common'

// components
import { Cover } from 'components/common'

import { handleErrorSideEffects } from './utils'

const AppError = ({
  message = '',
  refreshButtonContent = 'Refresh',
  redirectUrl = HOME_PAGE_URL,
}: {
  message?: string
  refreshButtonContent?: string
  redirectUrl?: string
}): ReactElement => {
  const refreshPage = useCallback(() => {
    window.location.href = redirectUrl
  }, [redirectUrl])

  useEffect(() => {
    if (message) {
      handleErrorSideEffects({ message, refreshPage })
    }
  }, [message, refreshPage])

  return (
    <Cover
      onClick={refreshPage}
      buttonContent={refreshButtonContent}
      message={
        <>
          <h2 className='fw-lighter'>Something went wrong </h2>
          <h4> {message}</h4>
        </>
      }
    />
  )
}

export default AppError
